import logo from './logo.svg';
import './App.css';
import { Header } from './components/HeaderFooter/Header';
import { Route, Routes } from 'react-router-dom';
import { Home } from './components/Screens/Home';
import { AboutUs } from './components/Screens/Aboutus';
import { ConatctUs } from './components/Screens/Contactus';
import { Product } from './components/Screens/Product'
import { Cart } from './components/Screens/Cart'
import { Checkout } from './components/Screens/Checkout';
import { Category } from './components/Screens/Category';
import { HomePage } from './components/Screens/HomePage';
import Footer from './components/HeaderFooter/Footer';
import { BuynowCheckout } from './components/Screens/BuynowCheckout';

function App() {
  return (
    <div className="App">
    <Header/>
      <>
        <Routes>
          {/* <Route path="/*" element={<Home/>} /> */}
          <Route path="/" element={<HomePage/>} />
          <Route path='/aboutus' element={<AboutUs />} />
          <Route path='/contactus' element={<ConatctUs />} />
          <Route path='/product/:id' element={<Product />} />
          <Route path='/cart' element={<Cart />} />
          <Route path='/checkout' element={<Checkout />} />
          <Route path='/category/:id' element={<Category />} />
          <Route path='/buynow-category' element={<BuynowCheckout />} />
          </Routes>
      </>
      <Footer />
    </div>
  );
}

export default App;
